import { FormGroup } from '@angular/forms';
var PlantHandlingInstructionsFormComponent = /** @class */ (function () {
    function PlantHandlingInstructionsFormComponent() {
    }
    Object.defineProperty(PlantHandlingInstructionsFormComponent.prototype, "plantHandlingInstructions", {
        get: function () {
            return this.treatment.get('plantHandlingInstructions');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsFormComponent.prototype, "lighting", {
        get: function () {
            return this.plantHandlingInstructions.get('lighting');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsFormComponent.prototype, "temperature", {
        get: function () {
            return this.plantHandlingInstructions.get('temperature');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsFormComponent.prototype, "humidity", {
        get: function () {
            return this.plantHandlingInstructions.get('humidity');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsFormComponent.prototype, "imagingNeeded", {
        get: function () {
            return this.plantHandlingInstructions.get('imagingNeeded');
        },
        enumerable: true,
        configurable: true
    });
    PlantHandlingInstructionsFormComponent.prototype.copyValueFrom = function (copyArgs) {
        this.plantHandlingInstructions.patchValue(copyArgs);
        this.plantHandlingInstructions.updateValueAndValidity();
    };
    return PlantHandlingInstructionsFormComponent;
}());
export { PlantHandlingInstructionsFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions-form/plant-handling-instructions-form.component.ts.pre-build-optimizer.js